<template>
  <a-select
    class="autocomplete-select"
    show-search
    allowClear
    :disabled="disabled"
    :value="value"
    :placeholder="_placeHolder"
    style="width: 100%"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="loading ? undefined : null"
    @search="handleSearch"
    @change="handleChange"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item in purchaseOrderList" :key="item.purchaseOrderId" :option="item">
      {{ item.purchaseOrderSn }}
    </a-select-option>
  </a-select>
</template>

<script>
import api from '@/service/api'
import http from '@/service/axios'
import debounce from '@/common/debounce'
import deepClone from '@/common/deepClone'

export default {
  data() {
    return {
      value: undefined,
      purchaseOrderList: [],
      choosedData: null,
      loading: false,
    }
  },
  computed: {
    _placeHolder() {
      return this.placeholder || this.$t(`搜素采购单`)
    },
  },
  props: {
    defaultValue: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    warehouseCode: {
      type: String,
    },
  },
  methods: {
    clear() {
      this.value = undefined
      this.purchaseOrderList = []
    },
    searchPurchaseList: debounce(function (value) {
      if (!value) return
      this.loading = true
      let data = {
        purchaseOrderSn: value,
        pageNo: 1,
        pageSize: 50,
        warehouseCode: this.warehouseCode,
      }
      http({
        url: api.purchaseOrderList,
        type: 'post',
        data,
        hasLoading: false,
        success: (res) => {
          let purchaseOrderList = res.result?.purchaseOrderList
          if (purchaseOrderList.length > 0) {
            this.purchaseOrderList = purchaseOrderList
          } else {
            this.$warning(this.$t('暂无数据'))
            this.choosedData = {}
          }
          this.loading = false
        },
      })
    }, 800),
    handleSearch(value) {
      this.searchPurchaseList(value)
    },
    handleChange(value, option) {
      this.value = value
      this.choosedData = option?.data?.attrs?.option
    },
  },
  watch: {
    choosedData(val) {
      this.$emit('selected', deepClone(val || {}))
    },
    defaultValue(val) {
      this.value = val
    },
  },
}
</script>
